import { css } from '@emotion/css'
import { spacing } from '@offerzen/pinata-shame'

const styles = {
  body: css({
    flexDirection: 'column',
    padding: spacing.medium,

    '& > * + *': {
      marginTop: spacing.default,
    },
  }),

  employmentPreference: css({
    display: 'flex',
    flexDirection: 'column',
  }),

  title: css({
    display: 'flex',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: spacing.default,
    },
  }),

  details: css({
    marginTop: -spacing.extraSmall,
    marginLeft: 30 + spacing.default, // Icon width is 30px
  }),
}

export default styles
